import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from './shared.service';

@Injectable()

export class ExternalResourceService {
    constructor(private _http: HttpClient, private _shared: SharedService) {}

    // Get all resources
    getExternalResources(): Observable<any> {
        return this._http.get<any>(this._shared.apiPath + 'externalResource').pipe(catchError(this._shared.handleError));
    }

    // Add new resource
    addExternalResource(data): Observable<any> {
        return this._http.post<any>(this._shared.apiPath + 'externalResource', data).pipe(catchError(this._shared.handleError));
    }

    // Remove resource
    deleteExternalResource(id: number): Observable<any> {
        return this._http.delete(this._shared.apiPath + 'externalResource/' + id).pipe(catchError(this._shared.handleError));
    }

    // Update resource order
    updateResourceOrder(order): Observable<any> {
        return this._http.put<any>(this._shared.apiPath + 'externalResource', order).pipe(catchError(this._shared.handleError));
    }
}